const Ring = function (quality) {
  return {
    slot: 'ring',
    type: 'ring',
    quality: quality,
  };
};
module.exports = Ring;
